import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function InHomeOpenVisitsEmptyState() {
  return (
    <Stack sx={{ flex: 1, justifyContent: "center" }} spacing={5}>
      <Title semibold variant="h4" component="h3" sx={{ textWrap: "balance", textAlign: "center" }}>
        There are no visits available
      </Title>
      <Text
        semibold
        variant="body2"
        sx={{ paddingBottom: 8, textWrap: "balance", textAlign: "center" }}
      >
        We&apos;ll send you a notification when new visits are available
      </Text>
    </Stack>
  );
}
